import { AppEventV1 } from '../events/app-events.js';
import { defineRoute } from '../route/define-route.js';
/**
 * The live-update stream (1.0b deliverable 14): server-sent `AppEventV1` frames, one JSON `data`
 * line each (P0-3's framing). Off in mock mode: the mock answers 501 `sse_not_mocked`. A stream
 * never ends, so a sweep's success case could not read its answer: the route declares a success
 * skip, keeps its 401 cases, and 1.1's own specs prove the stream.
 */
export const eventsStream = defineRoute({
    id: 'events.stream',
    method: 'GET',
    path: '/api/events',
    response: { kind: 'sse', union: AppEventV1 },
    auth: 'session',
    smoke: 'read',
    reference: 'none',
    status: 'frozen',
    owner: '1.1',
    since: 'editor-alpha',
    examples: {
        response: [{ type: 'sys.heartbeat', v: 1, data: { at: '2026-09-12T19:00:00.000Z' } }],
        success: {
            skip: 'an event stream never ends, so a success case cannot read its answer; 1.1 proves the stream',
        },
    },
});
//# sourceMappingURL=events.js.map